import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DataMatchingService, DataMatchingStatus } from "./data-matching.service";
import { TableView } from '../../../helpers/tableview';
import { FormErrors } from "../../login/auth.service";
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import 'rxjs/add/operator/toPromise';

@Component({
    selector: 'data-matching-overview',
    templateUrl: './data-matching.component.html',
    styleUrls: ['./data-matching.component.scss'],
    providers: [DataMatchingService]
})

export class AdminDataMatchingPage implements OnInit, OnDestroy {

    public table: TableView;

    public uploaderSettings = {
        url: '/',
        queueLimit: 1,
        allowedMimeType: ['text/csv'],
    };

    public uploader: FileUploader = new FileUploader(this.uploaderSettings);
    public errors: FormErrors = new FormErrors;
    public DataMatchingStatus = DataMatchingStatus;

    @ViewChild('fileInput')
    fileInput: ElementRef;

    constructor(private dataMatchingService: DataMatchingService){
    }

    ngOnInit() {
        this.table = new TableView(filter => this.dataMatchingService.getFiles(filter));
        this.table.filter.status = 0;
        this.table.filter.sortBy = "id";
        this.table.filter.sortAsc = false;
        this.table.applyFilter();
        this.table.refreshEvery(10);
    }

    ngOnDestroy() {
        this.table.refreshEvery(0);
    }

    public upload() {
        this.errors.clear();

        if (this.uploader.queue.length == 0) {
            this.errors.add({field: "files", type: "required"});
            return;
        }

        this.dataMatchingService.upload(this.uploader.queue)
        .then(result => {
            if (result) {
                this.uploader.queue[0].remove();
                this.fileInput.nativeElement.value = "";

                this.table.filter.status = 0;
                this.table.setPage(1);
            }
        }, err => {
            console.log("Upload failed: " + err);
        });
    }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/data-matching/data-matching.component.ts